import { Box, Typography } from "@mui/material";
function UsersIndex(props: any) {

    return (
        <Box sx={{margin: 20 }} display="flex" flexDirection="column" alignContent="stretch">
        <Typography variant="h5" mb={10}>Users</Typography>
        </Box>
    );
  }
  
  export default UsersIndex;